module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAmElEQVRYR+2XMQ7AIAhFy9E4OUdrJx1+wEYggQFHjeHxRIMkIu+jDGYmbd47Z8WhNgArYwvImznuwzjbQDmARZqVed8aWBkuwuzqR4MYZ1+1tgDRW4FGrw20AdBq43Rs1prbQBnA6R3wFO61gQEYA2NgDLQ0EGlkU17CcoBIn5hiIBUgovMGpG9XjGcSbcH+rMzPCA2V/44/mxRXAOsJ1W0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/drawtool/DRAWWORD_N.png
// module id = CUXc
// module chunks = 18